// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c34da3bf","732":"63b201a6"}[chunkId] + ".chunk.js";
};